export const positiveOrNaN = (number) => {
	if (number !== null && number >= 0) {
		return number
	}
	return NaN
}